<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Page Report</h3>
            </d-col>
        </d-row>

        <d-card class="card-small mb-4" v-if="reports.length > 0">
            <d-card-header class="border-bottom">
                <d-row>
                    <d-col sm="3" xs="12" class="mb-2">
                        <h6 class="m-0">My Reports</h6>
                    </d-col>
                </d-row>
            </d-card-header>

            <d-card-body>
                <p>You can view a report which was generated. Any of them are available only during 3 days after generation date.</p>
                <div
                    class="dataTables_wrapper domain-table VueTables VueTables--client"
                    v-if="reports"
                >
                    <div class="table-responsive">
                        <table class="VueTables__table transaction-history table dataTable">
                            <thead>
                            <tr>
                                <th class="VueTables__sortable">
                                    <span title="" class="VueTables__heading">Requested At</span>
                                </th>
                                <th class="VueTables__sortable">
                                    <span title="" class="VueTables__heading">Status</span>
                                </th>
                                <th class="VueTables__sortable">
                                    <span title="" class="VueTables__heading">Website</span>
                                </th>
                                <th class="VueTables__sortable network-table d-none d-lg-table-cell">
                                    <span title="" class="VueTables__heading">Date From</span>
                                </th>
                                <th class="VueTables__sortable d-none d-lg-table-cell">
                                    <span title="" class="VueTables__heading">Date To</span>
                                </th>
                                <th class="VueTables__sortable d-none d-lg-table-cell">
                                    <span title="" class="VueTables__heading">Action</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="report in reports">
                                    <td>{{ report.requested_at }}</td>
                                    <td><span :class="getStatus(report).css">{{ getStatus(report).text }}</span></td>
                                    <td>{{ report.website.domain }}</td>
                                    <td>{{ report.period_from }}</td>
                                    <td>{{ report.period_to }}</td>
                                    <td>
                                        <template v-if="getStatus(report).text === 'Generated'">
                                            <d-link :to="'page-report/' + report.id">View</d-link>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </d-card-body>
        </d-card>

        <d-card class="card-small">

            <d-card-header class="border-bottom">
                <d-row>
                    <d-col sm="3" xs="12" class="mb-2">
                        <h6 class="m-0">Parameters</h6>
                    </d-col>
                </d-row>
            </d-card-header>

            <d-list-group flush>
                <d-list-group-item class="pl-3 pr-3 pt-4 pt-0">
                    <d-row>
                        <d-col>
                            <d-form id="performanceForm" @submit.prevent="">
                                <d-form-row>
                                    <d-col lg="4" class="form-group performance-form">
                                        <d-input-group class="date-range">
                                            <calendar-picker :date-range="dateRange"/>
                                        </d-input-group>
                                    </d-col>
                                    <d-col lg="4" class="form-group performance-form">
                                        <b-form-select
                                            @change="setWebsite"
                                        >
                                            <option
                                                v-for="item in websites"
                                                :key="item.id"
                                                :value="item.id"
                                            >
                                                {{ item.domain }}
                                            </option>
                                        </b-form-select>
                                    </d-col>
                                </d-form-row>
                            </d-form>
                        </d-col>
                    </d-row>
                </d-list-group-item>
            </d-list-group>
        </d-card>

        <div class="text-center my-4">
            <b-button
                @click="request"
                variant="success"
                size="lg"
                :disabled="isLoading"
            >
                Generate Report
            </b-button>
        </div>
    </d-container>
</template>

<script>
    import notification from '@/mixins/notification'
    import loader from '@/mixins/loader'
    import { WebsiteService, AnalysisService, AuthService } from '@/main'
    import DateHelper from '@/helpers/date';
    import CalendarPicker from '@/components/form/calendarPicker.vue';
    import dashboardStatus from "@/helpers/dashboardStatus";

    export default {
        mixins: [notification, loader],

        components: {
            CalendarPicker,
        },

        data() {
            return {
                reports: [],
                isLoading: false,
                dateRange: { from: '', to: '' },
                websites: [],
                websiteId: '',

                restUrl: process.env.VUE_APP_REST_API,
                token: AuthService.getToken()
            }
        },

        methods: {
            getStatus(report) {
                if (! report.generated_at) {
                    return {
                        css: dashboardStatus.getStatusClass('Pending'),
                        text: 'Pending'
                    }
                }

                return {
                    css: dashboardStatus.getStatusClass('Approved'),
                    text: 'Generated',
                }
            },

            setWebsite(websiteId) {
                this.websiteId = websiteId
            },

            validateParameters() {
                if (this.dateRange.from === '' && this.dateRange.to === '') {
                    throw new Error('Should be correct the range of dates!');
                }

                if (! this.websiteId) {
                    throw new Error('Please select a domain!');
                }
            },

            async request() {
                this.isLoading = true
                try {
                    this.validateParameters()
                    await AnalysisService.requestPageReport(
                        DateHelper.formatDate(this.dateRange.from),
                        DateHelper.formatDate(this.dateRange.to),
                        this.websiteId
                    )

                    await this.getListPageReports()

                    this.isLoading = false

                    this.showNotification('success', 'Request was sent! You will get notification when report be ready.')

                } catch (e) {
                    this.showNotification('warn', 'Report can\'t be loaded', e.message)
                }
            },

            async getListPageReports() {

                try {
                    this.reports = await AnalysisService.listPageReports()
                } catch(e) {
                    this.showNotification('warn', 'Oops! we have a problem', 'Something went wrong!')
                    console.error(e)
                }
            },

            async getWebsites() {
                try {
                    this.websites = await WebsiteService.get()
                } catch (e) {
                    this.showNotification('warn', 'Oops! we have a problem', 'Oops! cant get domains')
                    console.error(e)
                }
            },
            setDateRange() {
                this.dateRange.from = DateHelper.getCurrentMonthStart()
                this.dateRange.to = DateHelper.getDateToday()
            }
        },

        mounted() {
            this.getWebsites()
            this.setDateRange()
            this.getListPageReports()
        },
    }
</script>
